import React from 'react';
import { isInApp } from '@umu/umu-ua';
const isApp = isInApp();

interface IProps {
    children: JSX.Element | JSX.Element[];
}
export const HideInApp = (props: IProps) => {
    if (isApp) {
        return <div className="app-placeholder"></div>;
    }
    return <>{props.children}</>;
};

export const ShowInApp = (props: IProps) => {
    if (isApp) {
        return <>{props.children}</>;
    }
    return null;
};
